import type { Dayjs } from 'dayjs'
import dayjs from 'dayjs'
import styles from './Month.module.scss'
import { getCalendarDays, getStartDate, getCalendarEndDate } from '../../../../utils'
import { useEventsStore } from 'store/useEventsStore'
import DaysOfWeekHeader from '../DaysOfWeekHeader/DaysOfWeekHeader'
import Day from '../Day/Day'
import { ConditionalWrapper } from '~elements'
import { DayjsInput } from 'utils/dayjs'

type MonthProps = {
  month: Dayjs
  handleDateSelection: (date: DayjsInput) => void
}

const Month = ({ month, handleDateSelection }: MonthProps) => {
  //Extract eventsByDate from the store
  const { eventsByDateForSingleArtist: eventsByDate } = useEventsStore()

  //Generate calendar days for the month
  const today = dayjs()
  const startDate = getStartDate(month, 'desktop', today)
  const endDate = month.endOf('month')
  const calendarStartDate = startDate.startOf('week')

  //Calculate calendar end date only for desktop variant to fill the last week
  const calendarEndDate = getCalendarEndDate(endDate)

  //Generate weeeks and days for the calendar month view
  const weeks = getCalendarDays(startDate, calendarStartDate, calendarEndDate, eventsByDate)

  return (
    <div className={styles['calendar__month']}>
      <DaysOfWeekHeader />
      {weeks.map((week, weekIdx) => (
        <ConditionalWrapper
          key={weekIdx}
          condition={true}
          wrapper={children => (
            <div key={`week_${weekIdx}`} className={styles['calendar__week']}>
              {children}
            </div>
          )}
        >
          {week.map(dayInfo => (
            <Day key={dayInfo.date.toISOString()} handleDateSelection={handleDateSelection} dayInfo={dayInfo} />
          ))}
        </ConditionalWrapper>
      ))}
    </div>
  )
}

export default Month
